import { Alert, Stack } from '@mui/material';
import { CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import { CuriosityAutocompleteField, DateRangeField } from '@procureai/ui-form-mui';
import { isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { TsrctSourcingCaseQuote, TsrctSourcingCaseQuoteItemStatus } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';

export interface SourcingCaseQuoteHeaderProps {
  data: Union.Nullable<TsrctSourcingCaseQuote>;
}

export const SourcingCaseQuoteHeader = ({ data }: SourcingCaseQuoteHeaderProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'SourcingCaseQuoteWidget' });
  const disabledCount = data?.lineItems.filter(
    (item) => item.status === TsrctSourcingCaseQuoteItemStatus.NOT_REQUESTED,
  ).length;

  return (
    <Stack direction="column" spacing={4}>
      <Stack direction="row" spacing={4}>
        <DateRangeField label={t('label.validityPeriod')} value={[data?.validFrom, data?.validTo]} viewOnly />
        <CuriosityAutocompleteField
          label={t('label.paymentTerms')}
          value={data?.paymentTermsId}
          viewOnly
          ns={CuriosityNamespaceType.PAYMENT_TERM}
        />
        <CuriosityAutocompleteField
          label={t('label.incoTerms')}
          value={data?.incoTermsId}
          viewOnly
          ns={CuriosityNamespaceType.INCO_TERM}
        />
      </Stack>
      {isNotNil(disabledCount) && disabledCount > 0 && (
        <Alert severity="info">{t('label.disabledLineItems', { count: disabledCount })}</Alert>
      )}
    </Stack>
  );
};
